import { render, staticRenderFns } from "./Alibaba-product-add.vue?vue&type=template&id=104ec857&scoped=true&"
import script from "./Alibaba-product-add.vue?vue&type=script&lang=js&"
export * from "./Alibaba-product-add.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-product-add.vue?vue&type=style&index=0&id=104ec857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104ec857",
  null
  
)

export default component.exports